// extracted by mini-css-extract-plugin
module.exports = {"s":"Loader_s__1OjlI","zast":"Loader_zast__1V3EP","Loader":"Loader_Loader__1eOiE","Loader__Circle":"Loader_Loader__Circle__2jswv","SpinAround":"Loader_SpinAround__ojiQH"};